import {Component, computed, input, ChangeDetectionStrategy} from '@angular/core';
import {SeFeChipModule} from 'se-fe-chip';
import {getTableRowId, isTableRowActive, ProductTableRow} from '../../product-table/product-table-row';

@Component({
  selector: 'product-status-cell',
  imports: [SeFeChipModule],
  templateUrl: './product-status-cell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-status-cell.component.scss',
})
export class ProductStatusCellComponent {
  product = input.required<ProductTableRow>();

  id = computed(() => getTableRowId(this.product()) || '');
  text = computed(() => (isTableRowActive(this.product()) ? 'Active' : 'Inactive'));
  style = computed(() => (isTableRowActive(this.product()) ? 'done' : 'off'));
}
